import { render, staticRenderFns } from "./AppFooterCategoryPopup.vue?vue&type=template&id=004fbbee&"
import script from "./AppFooterCategoryPopup.vue?vue&type=script&lang=js&"
export * from "./AppFooterCategoryPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports